module.exports = __webpack_public_path__ + "assets/img/government.75ab7339.svg";